import LocalStorage from "./LocalStorage"
import Settings from "./SettingsService"
import AccountService from "./AccountService"

function encodeCustomParams(customParams) {
    let result = ''
    for (const prop in customParams) {
        if (result.length > 0) {
            result += ','
        }
        result += `${prop}:${customParams[prop]}`
    }
    return result
}

function optionsToStr(options)
{
    let url = "";
    if (!options) {
        return url;
    }

    let isFirst = true;
    for (const prop in options) {
        url += isFirst ? '?' : '&';
        isFirst = false;
        let value = options[prop]
        if (prop == 'custom') {
            value = encodeCustomParams(value)
        }
        url += `${prop}=${value}`;
    }

    return url;
}

class NativeInterface
{
    ON_WEBVIEW_SHOW = 'ON_WEBVIEW_SHOW'
    ON_WEBVIEW_HIDE = 'ON_WEBVIEW_HIDE'

    IS_PWA = false;
    appInstanceId = ''

    subscribers = {}

    constructor() {
        if ('Native' in window) {
            this.IS_PWA = true;
        }
        
        console.log("Initializing window.DimxInterface")
        window.DimxInterface = {};
        window.DimxInterface['onWebViewShow'] = this.onWebViewShow.bind(this)
        window.DimxInterface['onWebViewHide'] = this.onWebViewHide.bind(this)

        window.addEventListener('message', this.onWindowMessage.bind(this)/*, false*/);
    }

    isPWA() {
        //return true;
        return this.IS_PWA;
    }
    handleApiVersionError(error) {
        console.log(`API_VERSION error: ${error}`)
        if (this.isPWA()) {
            // call native app..
            //window.Native.handleApiVersionError(error)
        }
    }
    launchNativeApp(options) {
        if (this.isPWA()) {
            const url = `https://go.dimx.world${optionsToStr(options)}`;
            const settingsData = LocalStorage.getRawString(Settings.STORAGE_PATH);
            const accountData = LocalStorage.getRawString(AccountService.STORAGE_PATH);
            window.Native.showAR(url, settingsData, accountData);
        } else {
            window.open(`app${optionsToStr(options)}`, '_blank');
        }
    }

    getAppInstanceId() {
        if (!this.appInstanceId) {
            if (this.isPWA()) {
                this.appInstanceId = window.Native.getAppInstanceId();
            } else {
                // read from local storage.. maybe
            }
        }
        return this.appInstanceId;
    }

    setWebAppHost(value) {
        if (this.isPWA()) {
            window.Native.setWebAppHost(value);
        }
    }

    requestGeolocationUpdate() {
        if (!this.isPWA()) {
            return;
        }
        return window.Native.requestGeolocationUpdate()
    }

    requestTrackingStatusUpdate(dimension) {
        if (!this.isPWA()) {
            return;
        }
        return window.Native.requestTrackingStatus(dimension)
    }

    registerCallback(name, callback) {
        console.log(`registerCallback window.DimxInterface: ${name}`)
        window.DimxInterface[name] = callback;
    }

    subscribeOnEvent(event, callback) {
        if (!this.subscribers[event]) {
            this.subscribers[event] = []
        }
        this.subscribers[event].push(callback)
    }

    unsubscribeOnEvent(event, callback) {
        if (this.subscribers[event]) {
            this.subscribers[event] = this.subscribers[event].filter(item => item !== callback)
        }
    }

    onWebViewShow() {
        console.log('NativeInterface.onWebViewShow')
        if (this.subscribers[this.ON_WEBVIEW_SHOW]) {
            this.subscribers[this.ON_WEBVIEW_SHOW].forEach(callback => {
                callback()
            });
        }
    }

    onWebViewHide() {
        console.log('NativeInterface.onWebViewHide')
        if (this.subscribers[this.ON_WEBVIEW_HIDE]) {
            this.subscribers[this.ON_WEBVIEW_HIDE].forEach(callback => {
                callback()
            });
        }
    }

    onWindowMessage(event) {
        console.log(`NativeInterface.onWindowMessage(${event.origin}): ${JSON.stringify(event.data)}`)
/*
        if (event.origin !== 'https://files.dimx.world') {
            return;
        }
*/
        if (event.data.command === 'PLACE_LOCATION') {
            if (this.isPWA()) {
                this.launchNativeApp({dim: event.data.dimension, loc: event.data.location, place: 1, custom: event.data.custom})
            }
        } else if (event.data.command === 'OPEN_EXTERNAL_URL') {
            window.open(event.data.url, '_blank');
        } else if (event.data.command === 'REQUEST_GEOLOCATION_UPDATE'){
            this.requestGeolocationUpdate();
        }
    }
}

const g_nativeInterface = new NativeInterface()
export default g_nativeInterface;
